import _slicedToArray from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
import React, { Component } from "react";
import { pickProps } from "@edenlabllc/ehealth-utils";
import Form from "./Form";
var STEP_FORM_PROPS = ["initialValues", "step", "transitions", "onSubmit"];
var StepForm = /*#__PURE__*/function (_Component) {
  _inherits(StepForm, _Component);
  var _super = _createSuper(StepForm);
  function StepForm() {
    var _this;
    _classCallCheck(this, StepForm);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      values: _this.props.initialValues
    };
    _this.handleSubmit = function (values, form) {
      var _this$props = _this.props,
        step = _this$props.step,
        transitions = _this$props.transitions,
        onSubmit = _this$props.onSubmit;
      var transition = transitions[step];
      _this.setState({
        values: values
      });
      var _form$getState = form.getState(),
        submitErrors = _form$getState.submitErrors;
      return transition ? transition(values, form) || submitErrors : onSubmit(values, form);
    };
    return _this;
  }
  _createClass(StepForm, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (JSON.stringify(prevProps.initialValues) !== JSON.stringify(this.props.initialValues)) {
        this.setState({
          values: this.props.initialValues
        });
        return true;
      }
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _pickProps = pickProps(this.props, STEP_FORM_PROPS),
        _pickProps2 = _slicedToArray(_pickProps, 2),
        props = _pickProps2[1];
      return /*#__PURE__*/React.createElement(Form, Object.assign({}, props, {
        initialValues: this.state.values,
        onSubmit: this.handleSubmit
      }));
    }
  }]);
  return StepForm;
}(Component);
export { StepForm as default };